__webpack_require__.p = "https://beta.au.safer.whs.amazon.dev/";